// extracted by mini-css-extract-plugin
export default {"header":"styles_header__a-Igl","header-text":"styles_header-text__QNRK5","sidebar-btn":"styles_sidebar-btn__D2SQ6"};